import React, { useState, useEffect } from "react";
import { Icon, Row, Col, Button, RSelect } from "../../../components/Component";
// import { getDateFormat } from "../../utils/Utils";
import { getDateFormat } from "../../../utils/Utils";
import DatePickerHeader from "./DatePickerHeader";
import DatePicker from "react-datepicker";
import { useSelector, useDispatch } from 'react-redux';
import { useMediaQuery, useMediaQueries } from '@react-hook/media-query';
// import "../../../assets/css/style.css";
import useResponsive from "../../../customHooks/useResponsive";

const SearchComponent = ({
  searchHandler,
  searchFieldData,
  seachFeildType,
  reloadHandler,
  setSearchText,
  setSelectedItems,
  checkResponse,
  setCurrentPage,
  pageName,
  showDatePicker = false,
  showSearchBar = true,
  toggle,
  toggleSearchModal
}) => {

  const dispatch = useDispatch();
  const { isMobile } = useResponsive();
  const [tablesm, updateTableSm] = useState(false);
  const [onSearch, setonSearch] = useState(showSearchBar);
  const [onRefreshPage, setOnRefreshPage] = useState(false);
  const key = Object.keys(searchFieldData);
  let updatedSearchFieldData = {};
  {
    key.map((field, i) => {
      updatedSearchFieldData[field] = "";
    });
  }

  const [state, setState] = useState(updatedSearchFieldData);
  const [rangeStart, setRangeStart] = useState();
  const [rangeEnd, setRangeEnd] = useState();
  const [isReset, setIsReset] = useState(false);


  useEffect(() => {
    setState({ ...searchFieldData });
    setRangeStart('');
    setRangeEnd('');
    setOnRefreshPage(true);
  }, [checkResponse])

  useEffect(() => {
    setState({
      ...state,
      ["startDate"]: "",
      ["endDate"]: "",
    });
  }, []);


  useEffect(() => {
    setState({
      ...state,
      ["startDate"]: rangeStart !== undefined ? getDateFormat(rangeStart) : "",
    });
  }, [rangeStart]);

  useEffect(() => {
    setState({
      ...state,
      ["endDate"]: rangeEnd !== undefined ? getDateFormat(rangeEnd) : "",
    });
  }, [rangeEnd]);

  // const toggle = () => {
  //   setonSearch(!onSearch);
  //   const keys = Object.keys(searchFieldData);
  //   Object.keys(searchFieldData).forEach((i) => (searchFieldData[i] = ""));
  // };

  const handleSearch = () => {
    if (state["startDate"] === "" || state["endDate"] === "") {
      setState({ ...state, ["startDate"]: "" });
      setState({ ...state, ["endDate"]: "" });
    }
    // const isEmpty = !Object.values(state).some((x) => x !== null && x !== "");
    // if (!isEmpty) {
    searchHandler(state);
    toggle();
    toggleSearchModal();
    // }
  };

  const keys = Object.keys(searchFieldData);

  const onChangeHandler = (evt) => {
    const value = evt.target.value;
    setState({
      ...state,
      [evt.target.name]: value,
    });
  };


  const onChangeParentCategoryHandler = (selectedValue, name) => {

    console.log(selectedValue);

    if (pageName == "order-revenue-chart") {
      dispatch({ type: 'SEARCH_DROPDOWN_VALUE', payload: selectedValue?.value })
    }



    setState({
      ...state,
      [name]: selectedValue,
    });

    // setState({
    //   ...state,
    //   [name]: selectedValue?.value,
    // });
  }

  const OnRefreshHandler = () => {
    setState({ ...searchFieldData });
    setRangeStart('');
    setRangeEnd('');
    reloadHandler();
    toggle();
    setOnRefreshPage(true);
    setSelectedItems([]);
    setCurrentPage(1);
    toggleSearchModal();
  };

  useEffect(() => {
    setOnRefreshPage(false);
    setState({ ...searchFieldData });
  }, [onRefreshPage]);

  const onEnterHandler = (e) => {
    if (e.key === "Enter") {
      searchHandler(state);
    }
  };


  const styles = {
    menu: (css) => ({
      ...css,
      width: "auto",
    }),
    control: (provided, state) => ({
      ...provided,
      background: '#fff',
      borderColor: '#9e9e9e',
      minHeight: '30px',
      height: '30px',
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: '30px',
      padding: '0 6px'
    }),

    input: (provided, state) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: '30px',
    }),
  };



  return (


    <div className="card-body">
      <Row>



        {keys.map((field, i) => {
          if (seachFeildType[field]?.tag === "input") {
            return (
              <Col md="2" className={`${isMobile ? "mb-1" : ""} `}>
                <input
                  type="text"
                  name={field}
                  className="form-control form-control-sm"
                  // placeholder={field}
                  placeholder={seachFeildType[field]?.optionName !== undefined ? seachFeildType[field]?.optionName : field}
                  onChange={(e) => onChangeHandler(e)}
                  onKeyDown={(e) => onEnterHandler(e)}
                  value={state?.['' + field + '']}

                //onChange={(e) => onFilterChange(e)}
                />
              </Col>
            );
          }
          if (seachFeildType[field]?.tag === "dropdown") {
            return (
              <Col md="2" className={`${isMobile ? "mb-1" : ""} `}>
                <RSelect
                  options={seachFeildType[field]?.options}
                  name={field}
                  placeholder={seachFeildType[field]?.optionName !== undefined ? seachFeildType[field]?.optionName : ""}
                  value={state?.['' + field + '']}
                  onChange={(val) => onChangeParentCategoryHandler(val, field)}
                  styles={styles}
                  isSearchable={false}
                />
              </Col>
            );
          }
        })}


        {showDatePicker && <>
          <Col md="2">
            <div>
              <div className="">
                <DatePicker
                  selected={rangeStart}
                  dateFormat="yyyy/MM/dd"
                  onChange={setRangeStart}
                  startDate={rangeStart}
                  endDate={rangeEnd}
                  maxDate={rangeEnd != 'undefined' ? new Date(rangeEnd) : null}
                  wrapperClassName="start-m"
                  className="form-control form-control-sm"
                  // onKeyDown={onEnterHandler}
                  onKeyDown={(e) => e.preventDefault()}
                  placeholderText="Start Date"
                  renderCustomHeader={({
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                  }) => {
                    return (
                      <DatePickerHeader
                        date={date}
                        changeYear={changeYear}
                        changeMonth={changeMonth}
                        decreaseMonth={decreaseMonth}
                        increaseMonth={increaseMonth}
                        prevMonthButtonDisabled={prevMonthButtonDisabled}
                        nextMonthButtonDisabled={nextMonthButtonDisabled}
                      />
                    );
                  }}
                />{" "}
              </div>
            </div>
          </Col>

          <Col md="1">
            <div className="input-group-addon">TO</div>
          </Col>

          <Col md="2">
            <div>
              <div className="">
                <DatePicker
                  selected={rangeEnd}
                  dateFormat="yyyy/MM/dd"
                  onChange={setRangeEnd}
                  startDate={rangeStart}
                  endDate={rangeEnd}
                  selectsEnd
                  wrapperClassName="end-m"

                  minDate={rangeStart != 'undefined' ? new Date(rangeStart) : null}

                  className="form-control form-control-sm"
                  // onKeyDown={onEnterHandler}
                  onKeyDown={(e) => e.preventDefault()}
                  placeholderText="End Date"
                  renderCustomHeader={({
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                  }) => {
                    return (
                      <DatePickerHeader
                        date={date}
                        changeYear={changeYear}
                        changeMonth={changeMonth}
                        decreaseMonth={decreaseMonth}
                        increaseMonth={increaseMonth}
                        prevMonthButtonDisabled={prevMonthButtonDisabled}
                        nextMonthButtonDisabled={nextMonthButtonDisabled}
                      />
                    );
                  }}
                />
              </div>
            </div>
          </Col>
        </>
        }


        <Col md="2">
          <div className="small-search-handle">
            <Button
              onClick={handleSearch}
              style={{ background: "#efefef" }}
              className={`mr-2 btn-icon`}
              // className={`${!isMobile && "mr-2"} btn-icon`}
            >
              <Icon name="search"></Icon>
            </Button>
            <Button
              onClick={OnRefreshHandler}
              style={{ background: "#efefef" }}
              className={`btn-icon`}
              // className={`${!isMobile && "mr-2"} btn-icon`}
            >
              <Icon name="reload"></Icon>
            </Button>
          </div>
        </Col>

      </Row>
    </div>
  );
};

export default SearchComponent;